import { TenderTypes, type ConfigTender, type Tender } from '@centric-os/types';
import { DateTime } from 'luxon';

/**
 * Maps config service tender to form state
 * @param {Partial<ConfigTender>} tender - The tender to map.
 * @returns {Tender} The mapped tender.
 */
export const mapTenderConfig = (tender: Partial<ConfigTender>): Tender => {
  const base_tender = {
    tender_number: tender.tender_number,
    name: tender.name,
  };
  if (tender.type === TenderTypes.MEAL_EQUIVALENT) {
    return {
      ...base_tender,
      type: TenderTypes.MEAL_EQUIVALENT,
      tax_exempt: tender.tax_exempt,
      id: tender.id,
      max_swipes_per_transaction: tender.max_swipes_per_transaction,
      rates: tender.rates.map((rate) => {
        return {
          amount: rate.amount / 100,
          startTime: rate?.hours
            ? DateTime.fromFormat(rate.hours.split('-')[0], 'HH:mm').toJSDate()
            : null,
          endTime: rate?.hours
            ? DateTime.fromFormat(rate.hours.split('-')[1], 'HH:mm').toJSDate()
            : null,
        };
      }),
    };
  }
  if (tender.type === TenderTypes.DECLINING_BALANCE) {
    return {
      ...base_tender,
      type: TenderTypes.DECLINING_BALANCE,
      id: tender.id,
      tax_exempt: tender.tax_exempt,
      ...(tender.stipend_split === true ? { stipend_split: true } : {}),
    };
  }
  if (tender.type === TenderTypes.MEAL_EXCHANGE) {
    return {
      ...base_tender,
      type: TenderTypes.MEAL_EXCHANGE,
      id: tender.id,
    };
  }
};
